import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import React from 'react';

const Spinner: React.FC<Partial<{ color: string; spinning: boolean; size: number; children: React.ReactNode }>> = ({
  color,
  spinning,
  children,
  size = 24,
}) => {
  const antIcon = <LoadingOutlined style={{ fontSize: size, color: color || 'white' }} spin />;
  return (
    <Spin style={{ margin: 0 }} indicator={antIcon} spinning={spinning}>
      {children}
    </Spin>
  );
};

export default React.memo(Spinner);
